import { registerQuery } from 'data-fetching-client';
import { createRpcClientV2 } from 'rpc-client-utils';
import authHttpClient from 'hub-http/clients/apiClient';
import { getRecommendationsRpc } from 'automation-ui-canvas/__generated__/chirp/com/hubspot/automation/action/recommendation/rpc/AutomationActionRecommendationRpc';
const chirpClient = createRpcClientV2({
  hubHttpClient: authHttpClient
});
export const GET_NEXT_ACTION_RECOMMENDATION = registerQuery({
  fieldName: 'getNextActionRecommendation',
  args: ['actionTypeId1', 'actionTypeId2', 'actionTypeId3', 'actionTypeId4', 'flowObjectType'],
  fetcher(request) {
    return chirpClient.call(getRecommendationsRpc, {
      request
    }).then(res => {
      // V1 of the action recommendation ONLY deals in built-in action so we need to add a zero- prefix to get an actionTypeId
      const nextActionRecommendationOutput = {};
      Object.entries(res.actionTypeIdInnerIdsToScores).forEach(([actionTypeIdMissingPrefix, score]) => {
        const actionTypeId = `0-${actionTypeIdMissingPrefix}`;
        nextActionRecommendationOutput[actionTypeId] = score;
      });
      return {
        chirpAiContextObject: res.chirpAiContextObject,
        actionTypeIdInnerIdsToScores: nextActionRecommendationOutput
      };
    });
  }
});